import { Component, input } from '@angular/core';

@Component({
  selector: 'syn-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss'],
})
export class EmptyPageComponent {
  readonly message = input<string>(undefined);
}
